import { useEffect, useState } from "react";
import {
  createDefaultWellWishes,
  dashboardStore,
  fetchDashboard,
  fetchLoggedInUser,
  fetchWellWishes,
  fetchGuestManager,
  metaStore,
  userStore,
  fetchMailCredits,
} from "./store";
import { WellWish } from "../types/wellwish";
import { UserWeddingRole } from "../types/wedding";
import { getWeddingParty } from "../apis/wedding-party/get.wedding.party";
import { editorState, updateEditor } from "../utils/editor";

export const useAccountInfo = (
  userWeddingRole: UserWeddingRole,
  XAccountHash?: string,
) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(userStore.data);
  const [dashboard, setDashboard] = useState(dashboardStore.data);
  const [wellWishes, setWellWishes] = useState<{
    wellWishesCount: number;
    wellWishes: WellWish[];
  }>(createDefaultWellWishes());

  const [weddingID, setWeddingID] = useState("");

  useEffect(() => {
    fetchLoggedInUser({
      XAccountHash,
      onComplete(CurrentData) {
        setUser(CurrentData);
        userStore.data = CurrentData;
        setLoading(false);

        if (CurrentData.weddingID) {
          setWeddingID(CurrentData.weddingID);
        }
      },
      onError(err) {
        if (err !== "DuplicateRequest") {
          setError(true);
        }
        setLoading(false);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const shouldFetch =
      userWeddingRole === UserWeddingRole.EventPlanner ? !!XAccountHash : true;
    if (shouldFetch) {
      fetchMailCredits({
        XAccountHash,
        onComplete(CurrentData) {},
        onError(err) {},
      });
      fetchGuestManager({
        XAccountHash,
        onComplete(CurrentData) {},
        onError(err) {},
      });
      fetchDashboard({
        XAccountHash,
        onComplete(CurrentData) {
          setDashboard(CurrentData);
          setLoading(false);
          // Only show onboarding modal if hasNotOnboarded is true AND both names don't exist
          // const bothNamesExist = CurrentData.groomFirstName && CurrentData.brideFirstName;
          metaStore.showOnboardingModal = CurrentData.hasNotOnboarded;
        },
        onError(err) {
          if (err !== "DuplicateRequest") {
            setError(true);
          }
          setLoading(false);
        },
      });
      fetchWellWishes({
        XAccountHash,
        onComplete(CurrentData) {
          setWellWishes(CurrentData);
          setLoading(false);
        },
        onError(err) {
          if (err !== "DuplicateRequest") {
            setError(true);
          }
          setLoading(false);
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [XAccountHash]);

  useEffect(() => {
    if (weddingID) {
      getWeddingParty({
        headers: {
          "X-Account-Hash": XAccountHash || "",
        },
        query: {
          weddingID,
        },
        onCompleted(payload) {
          editorState.weddingParty = payload.data.weddingParties;
          updateEditor(payload.data.wedding);
        },
        onError(err) {
          console.error(err);
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [weddingID, XAccountHash]);

  return {
    user,
    dashboard,
    error,
    loading,
    wellWishes,
  };
};
